import { render, staticRenderFns } from "./PostEditImmoObject2300.vue?vue&type=template&id=ca6ba17a&"
import script from "./PostEditImmoObject2300.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoObject2300.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports